export default "__VITE_ASSET__BDzAKS1W__"